import { Events } from 'ionic-angular'
import { Component } from '@angular/core'
import { Location } from '../../services/location'

// Declare InfoBox to Typescript
declare function InfoBox(options: any): void

@Component({
  selector: 'map',
  template: '<div class="stop-map"></div>',
  providers: [Location]
})
export class Map {
  private map: any
  private stop: any
  private config: any

  constructor(private events: Events, location: Location) {
    this.stop = null
    this.config = {
      style: new google.maps.StyledMapType([{
        'featureType': 'poi',
        'elementType': 'labels.text',
        'stylers': [{
          'visibility': 'off'
        }]
      }, {
          'featureType': 'road.highway',
          'elementType': 'geometry',
          'stylers': [{
            'visibility': 'simplified'
          }, {
              'hue': '#ffd500'
            }, {
              'lightness': 20
            }]
        }, {
          'featureType': 'road.arterial',
          'elementType': 'labels.icon',
          'stylers': [{
            'visibility': 'simplified'
          }, {
              'lightness': 20
            }]
        }, {
          'featureType': 'road.highway',
          'elementType': 'labels.icon',
          'stylers': [{
            'visibility': 'simplified'
          }, {
              'lightness': 20
            }]
        }, {
          'featureType': 'landscape.natural',
          'stylers': [{
            'visibility': 'on'
          }, {
              'lightness': 30
            }]
        }], {
          name: 'Plan'
        }),
      options: {
        zoom: 15,
        center: new google.maps.LatLng(location.lat, location.lng),
        disableDefaultUI: true,
        minZoom: 12
      }
    }

    events.subscribe('carpostal:stop:location', (data) => {
      setTimeout(() => {
        this.stop = data.shift()

        // Zoom more to display the stop
        this.map.setZoom(17)

        // Add marker
        let marker = new google.maps.Marker({
          position: this.stop.getPosition(),
          icon: {
            url: '/img/marker.png',
            size: new google.maps.Size(20, 20),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(10, 10),
            scaledSize: new google.maps.Size(20, 20)
          },
          title: this.stop.title,
          map: this.map
        }) as any

        marker.id = this.stop.id
        marker.pmr = this.stop.pmr
        marker.lines = this.stop.lines

        this.map.panTo(marker.getPosition())

        // Display infobox
        // Build the lines infobox
        let div = '<div class="groups"><div class="mode">'
        for (let line of (<any>marker).lines) {
          div += '<span class="line" style="background: #' + line.color + '">' + line.code + '</span>'
        }
        div += '</div></div>'

        let content = '<div class="info">' +
          '<div class="title">' +
          (<any>marker).title +
          '</div>' +
          '<div class="content">' +
          div +
          '</div>' +
          '</div>'

        let myOptions = {
          content: content,
          disableAutoPan: true,
          maxWidth: '75%',
          boxStyle: {
            opacity: 1
          },
          closeBoxURL: '',
          infoBoxClearance: new google.maps.Size(0, 0),
          isHidden: false,
          enableEventPropagation: false
        }

        let ib = new InfoBox(myOptions)

        // Resize the infobox when it's dom is ready
        google.maps.event.addListener(ib, 'domready', () => {
          let info = <any>document.querySelector('.info')
          setTimeout(() => {
            ib.setOptions({
              pixelOffset: new google.maps.Size(-info.offsetWidth / 2, -info.offsetHeight - 15)
            })
          })
        })

        ib.open(this.map, marker)
      })
    })
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.map = new google.maps.Map(document.querySelector('.stop-map'), this.config.options)
      //Associate the styled map with the MapTypeId and set it to display.
      this.map.mapTypes.set('Plan', this.config.style)
      this.map.setMapTypeId('Plan')
    })
  }

  ngOnDestroy() {
    this.events.unsubscribe('carpostal:stop:location', null)
    this.events.unsubscribe('carpostal:stop:itinerary', null)
  }
}
